module.exports = __webpack_public_path__ + "img/collection-diamondJewelry.1ef7c61.jpg";